<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs4-04",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 56,
      nextPage: '/questionnaire/section4/5',
      navigateType: 'CLICK_NEXT',
      content: {
        layout: 'layout_left',
        componentsType: {
          pc: 'labelBtn',
          mobile: 'labelBtn'
        },
        mainTitle: 'Do you currently have any of the following physical problems?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Diabetes',
              operation: 'remove product FM-DIM-101 & remove product FM-VCOLB-101 & remove product FM-WMV-101 & remove product FM-ELDER-101 & flag1-4_None_add reminder 11'
            },{
              text: 'Hyperlipidemia',
              operation: 'remove product FM-DIM-101 & remove product FM-VCOLB-101 & remove product FM-WMV-101 & remove product FM-ELDER-101 & flag3-3_true_add suggestion 6 & flag1-4_None_add reminder 17'
            },{
              text: 'Hypertemsion',
              operation: 'remove product FM-DIM-101 & remove product FM-VCOLB-101 & remove product FM-WMV-101 & remove product FM-ELDER-101 & flag3-3_true_add suggestion 6 & flag1-4_None_add reminder 18'
            }
          ],[
            {
              text: 'Hyperglycemia',
              operation: 'remove product FM-DIM-101 & remove product FM-VCOLB-101 & remove product FM-WMV-101 & remove product FM-ELDER-101 & flag3-3_true_add suggestion 6 & flag1-4_None_add reminder 19'
            },{
              text: 'Gout',
              operation: 'remove product FM-WMV-101 & flag1-4_None_add reminder 20'
            },{
              text: 'Kidney Stone',
              operation: 'remove product FM-POSVI-101 & remove product FM-CRANB-101'
            }
          ],[
            {
              text: 'Thyoid problem',
              operation: 'remove product FM-PREVI-101 & remove product FM-POSVI-101'
            },{
              text: 'None of these',
              unique: true
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
